import React from "react";
import PropTypes from "prop-types";

import FormButton from "components/FormButton";

const FormActions = (props) => {
  const {
    isEdit,
    isHovered,
    isLarge,
    isSaveable,
    isValid,
    onCancel,
    onDelete,
    onEdit,
    onSave,
    withIcon,
  } = props;

  return (
    <>
      {isEdit ? (
        <>
          {onDelete && (
            <FormButton isLarge={isLarge} onClick={onDelete} type="delete" withIcon={withIcon} />
          )}
          <FormButton isLarge={isLarge} onClick={onCancel} type="cancel" withIcon={withIcon} />
          {(onSave || isSaveable) && isValid && (
            <FormButton isLarge={isLarge} onClick={onSave} type="save" withIcon={withIcon} />
          )}
        </>
      ) : (
        isHovered && (
          <FormButton isLarge={isLarge} onClick={onEdit} type="edit" withIcon={withIcon} />
        )
      )}
    </>
  );
};

FormActions.propTypes = {
  isEdit: PropTypes.bool,
  isHovered: PropTypes.bool,
  isLarge: PropTypes.bool,
  isSaveable: PropTypes.bool,
  isValid: PropTypes.bool,
  withIcon: PropTypes.bool,
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  onSave: PropTypes.func,
};

FormActions.defaultProps = {
  isValid: true,
};

export default FormActions;
